import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';

import { goToUrl } from '../Table/tableActions';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const PAYOUTS_LOAD = 'PAYOUTS/PAYOUTS_LOAD';
export const PAYOUTS_SUCCESS = 'PAYOUTS/PAYOUTS_SUCCESS';
export const PAYOUTS_FAILURE = 'PAYOUTS/PAYOUTS_FAILURE';

export const UPLOAD_PAYOUT_BATCH_LOAD = 'PAYOUTS/UPLOAD_PAYOUT_BATCH_LOAD';
export const UPLOAD_PAYOUT_BATCH_SUCCESS = 'PAYOUTS/UPLOAD_PAYOUT_BATCH_SUCCESS';
export const UPLOAD_PAYOUT_BATCH_FAILURE = 'PAYOUTS/UPLOAD_PAYOUT_BATCH_FAILURE';

export const fetchUrl = `${config.payoutApiUrl}`;

export function selectPayout(history, payout, newTab) {
    goToUrl(history, `/payout/${payout.id}`, newTab);
}

export function selectPayoutFromBatches(history, providerId, currency, batchRef) {
    goToUrl(history, `/payout?providerId=${providerId}&currency=${currency}&batchRef=${batchRef}`, true);
}

export function getPayouts(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'payoutDate',
        filters,
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getPayoutsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PAYOUTS_LOAD,
        successActionTypeOrCreator: getPayoutsSuccessActionCreator
    };
}

export function getPayoutsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PAYOUTS_SUCCESS, 'payouts');
}

export function getPayoutsFailureActionCreator(error) {
    return {
        error,
        type: PAYOUTS_FAILURE
    };
}

export function uploadPayoutBatch(csv) {
    const formData = new FormData();

    formData.append('', csv);

    return {
        failureActionTypeOrCreator: uploadPayoutBatchFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${fetchUrl}/batch`,
            body: formData,
            shouldStringifyBody: false
        },
        loadActionTypeOrCreator: UPLOAD_PAYOUT_BATCH_LOAD,
        successActionTypeOrCreator: UPLOAD_PAYOUT_BATCH_SUCCESS
    };
}

export function uploadPayoutBatchFailureActionCreator(error) {
    return {
        error,
        type: UPLOAD_PAYOUT_BATCH_FAILURE
    };
}
